import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  data: null, // Initial state
};

const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
    clearUserData: (state) => {
      state.data = null;
    },
  },
});

export const { setUserData, clearUserData } = userDataSlice.actions;
export default userDataSlice.reducer;

